export default __webpack_public_path__ + "static/media/teams_Footer_CrystalPalace_Sponsorship.1a710e14.svg";